// extracted by mini-css-extract-plugin
export default {"shareLinks":"ShareLinks_shareLinks__zfhOJ"};